import React from "react";
import { Box, Typography } from "@mui/material";

const Home = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        padding: 4,
        margin: "0 auto",
        maxWidth: { xs: "90%", sm: "80%", md: "60%" },
      }}
    >
      <Typography variant="h3" gutterBottom>
        Bem-vindo ao CNCG
      </Typography>
      <Typography variant="h5" gutterBottom>
        Aqui você pode gerenciar usuários e indicadores do sistema.
      </Typography>
      <Typography variant="body1" color="textSecondary">
        Use o menu acima para navegar pelas funcionalidades do sistema.
      </Typography>
    </Box>
  );
};

export default Home;
